/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Vehicle_Warranty_DescriptionInputs */

const en_case_section_vehicle_warranty_description = /** @type {(inputs: Case_Section_Vehicle_Warranty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The vehicle covered by the warranty.`)
};

const pt_br2_case_section_vehicle_warranty_description = /** @type {(inputs: Case_Section_Vehicle_Warranty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O veículo coberto pela garantia.`)
};

/**
* | output |
* | --- |
* | "The vehicle covered by the warranty." |
*
* @param {Case_Section_Vehicle_Warranty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_vehicle_warranty_description = /** @type {((inputs?: Case_Section_Vehicle_Warranty_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Vehicle_Warranty_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_vehicle_warranty_description(inputs)
	return pt_br2_case_section_vehicle_warranty_description(inputs)
});